import React from "react";
import { openOnRowClick } from '../../../utils/rowClick';

export const ManualEditsRow = ({ row, onClick, onViewProfile, roleFilter }) => {
  const handleViewProfile = (e) => {
    e.stopPropagation();
    onViewProfile(row);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <tr onClick={openOnRowClick(handleViewProfile)} className="cursor-pointer border-t border-jp-line hover:bg-jp-section">
      <td className="px-4 py-2 text-jp-ink">{row.name}</td>
      <td className="px-4 py-2 text-jp-ink">{row.teamName || '-'}</td>
      <td className="px-4 py-2 text-jp-ink">{row.role}</td>
      <td className="px-4 py-2 text-jp-ink">{row.lastUpdate}</td>
      <td className="px-4 py-2 text-jp-ink">{row.status}</td>
      {roleFilter !== 'coach' && roleFilter !== 'scout' && (
        <td className="px-4 py-2 text-jp-ink">{row.commitmentStatus}</td>
      )}
      <td className="px-4 py-2">
        {row.role?.toLowerCase() !== "coach" && row.role?.toLowerCase() !== "scout" && (
          <div className="flex items-center gap-2">
            <button
              onClick={handleViewProfile}
              className="text-sky-600 dark:text-sky-400 text-[11px] hover:text-jp-accent transition-colors"
            >
              View Profile
            </button>
            <span className="text-jp-muted/70">|</span>
            <button
              onClick={handleEdit}
              className="text-jp-ink text-[11px] hover:underline"
            >
              Edit ✏️
            </button>
          </div>
        )}
      </td>
    </tr>
  );
};
